export const name = "ST_DISTANCE";
export const summary = `Gets the shortest distance in meters between two \`GEOGRAPHY\` values.`;
export const reference = `
## ST_DISTANCE

Gets the shortest distance in meters between two \`GEOGRAPHY\` values.

\`\`\`
ST_DISTANCE(geography_1, geography_2[, use_spheroid])
\`\`\`

### Description

Returns the shortest distance in meters between two non-empty\`GEOGRAPHY\`s.

If either of the input \`GEOGRAPHY\`s is empty,\`ST_DISTANCE\` returns \`NULL\`.

The optional \`use_spheroid\` parameter determines how this function measures distance. If \`use_spheroid\` is \`FALSE\`, the function measures distance on the surface of a perfect sphere. If \`use_spheroid\` is \`TRUE\`, the function measures distance on the surface of the WGS84 spheroid. The default value of \`use_spheroid\` is \`FALSE\`.


### Return type

\`FLOAT64\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
